import StatisticsService from "@/services/StatisticsService";
import { mapActions, mapGetters } from "vuex";
import { convertTypeToInt } from "@/utils/general";
import { dateArrToObj } from "@/utils/dates";

export default {
  data() {
    return {
      listStepsThatContainErrors: ["push", "sms", "notification", "webpush"],
    };
  },

  computed: {
    ...mapGetters({
      getStatDateRange: "getStatDateRange",
      getGroupby: "getGroupby",
    }),
    getListTypesStep() {
      return this.$route.name === "statistics-promotion"
        ? this.actualTabs.slice(1).map(tab => tab.id)
        : this.$route.name === "statistics-mailout"
          ? this.$route.query.type
          : this.$route.params.type;
    },
    getRequestBody() {
      const { params: { id }, query: { taskid, launchid, stepid } } = this.$route;

      return {
        campuiid: id,
        taskid,
        launchid,
        stepid: stepid ? Number(stepid) : null,
      };
    },
    getRequestBodyUnsubscribes() {
      const unsubscribes = _.clone(this.getRequestBody);
      unsubscribes.page = 0;
      unsubscribes.query = "";
      return unsubscribes;
    },
  },

  methods: {
    ...mapActions({
      getStatDomains: "getStatDomains",
      getClickmap: "getClickmap",
      getStatUnsubscribe: "getStatUnsubscribe",
      getStatErrorsTop: "getStatErrorsTop",
      getStatErrors: "getStatErrors",
    }),
    async getStatistics(flag = true) {
      let requests = [this.getStatDomains(this.getRequestBody), this.getStatUnsubscribe(this.getRequestBodyUnsubscribes)];
      if (flag) requests.push(this.getClickmap(this.getRequestBody));
      await Promise.all(requests);
    },
    async getStatisticsErrors() {
      const requests = [this.getStatErrorsTop(this.getRequestBody), this.getStatErrors(this.getRequestBodyUnsubscribes)];
      await Promise.all(requests);
    },
    async updateGroupbyDetailsGeneral() {
      const listTypesStep = this.getListTypesStep;
      this.statMutation({ key: "details", value: true, parentKey: "loadings"});
      this.loadingRequestsActivated();
      let campstatsaudit = {};
      if (this.$route.name === "statistics-promotion") {
        const res = await Promise.all(listTypesStep.map(item => this.getDetailsByType(item))).then(data => data);
        listTypesStep.forEach((item, index) => {
          campstatsaudit[item] = res[index];
        });
        this.campstatsaudit = campstatsaudit;

        if (listTypesStep.includes('email'))
          await this.getStatistics();

        const listTypesWithErrors = listTypesStep.filter(type => this.listStepsThatContainErrors.includes(type));
        if (listTypesWithErrors.length) {
          this.getRequestBodyUnsubscribes.listTypesWithErrors = listTypesWithErrors;
          await this.getStatisticsErrors();
          delete this.getRequestBodyUnsubscribes.listTypesWithErrors;
        }
      }

      if (this.$route.name === "statistics-mailout") {
        campstatsaudit[listTypesStep] = await this.getDetailsByType(listTypesStep);
        this.campstatsaudit = campstatsaudit;

        if (listTypesStep === "email")
          await this.getStatistics();
        if (this.listStepsThatContainErrors.includes(listTypesStep))
          await this.getStatisticsErrors();
      }

      if (this.$route.name === "statistics-general") {
        campstatsaudit[listTypesStep] = await this.getDetailsByType(listTypesStep);
        this.campstatsaudit = campstatsaudit;
        if (listTypesStep === 'email')
          await this.getStatistics(false);
        if (this.listStepsThatContainErrors.includes(listTypesStep))
          await this.getStatisticsErrors();
      }
      this.statMutation({ key: "details", value: false, parentKey: "loadings"});
      this.loadingRequestsDeactivated();
    },

    async getAllCampStats() {
      const listTypesStep = this.getListTypesStep;
      let campstatsaudit = {};
      this.statMutation({ key: "details", value: true, parentKey: "loadings"});
      this.loadingRequestsActivated();
      if (this.$route.name === "statistics-promotion") {
        let campstats = {};
        const res = await Promise.all(
          listTypesStep.map(tab => {
            return StatisticsService.getCampStats({
              campuiid: this.$route.params.id,
              steptype: convertTypeToInt(tab),
              stepid: null,
            });
          })).then(data => data);
        listTypesStep.forEach((tab, index) => {
          campstats[tab] = res[index];
        });

        const resAudit = await Promise.all(listTypesStep.map(item => this.getDetailsByType(item))).then(data => data);
        listTypesStep.forEach((item, index) => {
          campstatsaudit[item] = resAudit[index];
        });
        this.campstatsaudit = campstatsaudit;
        this.allCampStats = campstats;

        if (listTypesStep.includes('email'))
          await this.getStatistics();

        const listTypesWithErrors = listTypesStep.filter(type => this.listStepsThatContainErrors.includes(type));
        if (listTypesWithErrors.length) {
          this.getRequestBodyUnsubscribes.listTypesWithErrors = listTypesWithErrors;
          await this.getStatisticsErrors();
          delete this.getRequestBodyUnsubscribes.listTypesWithErrors;
        }
      }

      if (this.$route.name === "statistics-mailout") {
        campstatsaudit[listTypesStep] = await this.getDetailsByType(listTypesStep);
        this.campstatsaudit = campstatsaudit;

        if (listTypesStep === "email")
          await this.getStatistics();
        if (this.listStepsThatContainErrors.includes(listTypesStep))
          await this.getStatisticsErrors();
      }

      if (this.$route.name === "statistics-general") {
        campstatsaudit[listTypesStep] = await this.getDetailsByType(listTypesStep);
        this.campstatsaudit = campstatsaudit;
        if (listTypesStep === 'email')
          await this.getStatistics(false);
        if (this.listStepsThatContainErrors.includes(listTypesStep))
          await this.getStatisticsErrors();
      }
      this.statMutation({ key: "details", value: false, parentKey: "loadings"});
      this.loadingRequestsDeactivated();
    },

    loadingRequestsActivated() {
      this.statMutation({ key: "domains", value: true, parentKey: "loadings" });
      this.statMutation({ key: "unsubscribe", value: true, parentKey: "loadings" });
      this.statMutation({ key: "clickmap", value: true, parentKey: "loadings" });
      this.statMutation({ key: "errorsTop", value: true, parentKey: "loadings" });
      this.statMutation({ key: "errors", value: true, parentKey: "loadings" });
    },
    loadingRequestsDeactivated() {
      this.statMutation({ key: "domains", value: false, parentKey: "loadings" });
      this.statMutation({ key: "unsubscribe", value: false, parentKey: "loadings" });
      this.statMutation({ key: "clickmap", value: false, parentKey: "loadings" });
      this.statMutation({ key: "errorsTop", value: false, parentKey: "loadings" });
      this.statMutation({ key: "errors", value: false, parentKey: "loadings" });
    },
    async getDetailsByType(stepType) {
      try {
        const options = {
          steptype: convertTypeToInt(stepType),
          ...this.getRequestBody,
          ...dateArrToObj(this.getStatDateRange),
        };
        const byHour = StatisticsService.getStatDetailsByDate({ ...options, groupby: 1 });
        const byDay = StatisticsService.getStatDetailsByDate({ ...options, groupby: 2 });
        const byWeek = StatisticsService.getStatDetailsByDate({ ...options, groupby: 3 });
        const byMonth = StatisticsService.getStatDetailsByDate({ ...options, groupby: 4 });

        let detailsByType = {};

        await Promise.all([byHour, byDay, byWeek, byMonth])
          .then(([byHour, byDay, byWeek, byMonth]) => {
            detailsByType = {
              byHour,
              byDay,
              byWeek,
              byMonth,
            };
          });
        return detailsByType;
      } catch (e) {
        console.log(e);
        return;
      }
    },
  },
};